import jsPDF from 'jspdf';
import {SwissFieldBase} from '../swiss-forms/fields/swiss-field-base';
import {ObjectData} from '../services/objekt-data.service';
import {DokumentModels} from './dokument-models';

export namespace ObjektModels {

    import DokumentInfo = DokumentModels.DokumentInfo;

    export interface ObjektElement {
        objectID: string;
        parentObject?: string;
        objectNumber: string;
        objectType: string; // muss string sein wegen DropDown-Komponente von Angular
        status: string; // muss string sein wegen DropDown-Komponente von Angular
        description: string;
        address?: string;
        zipCode?: string;
        town?: string;
        note1: string;
        note2: string;
        note3: string;
        note4: string;
        manufacturingDescription?: string;
        memo?: string;
        mandator?: string;
        prodStart?: Date;
        dateOfCompletion?: Date;
        dateOfDelivery?: Date;
        dateOfAssembly?: Date;
        fk_CompanypartID?: string; // muss string sein wegen DropDown-Komponente von Angular
        fk_CostUnitID?: string; // muss string sein wegen DropDown-Komponente von Angular
        created?: Date;
        createdBy?: string;
        modified?: Date;
        modifiedBy?: string;
        acdcVar?: number;
        password?: string;
        totalHours?: string;
    }

    export const EmptyObjektElement = (): ObjektModels.ObjektElement => ({
        objectID: '',
        parentObject: undefined,
        objectNumber: '',
        objectType: '',
        status: '0',
        description: '',
        address: '',
        zipCode: '',
        town: '',
        note1: '',
        note2: '',
        note3: '',
        note4: '',
        manufacturingDescription: '',
        memo: '',
        mandator: '100',
        // prodStart: null,
        dateOfCompletion: undefined,
        dateOfDelivery: undefined,
        dateOfAssembly: undefined,
        totalHours: undefined
    });

    export interface ObjectListViewItem extends ObjectData {
        objectNumber: string;
        objectType: number;
        objectTypeDesc: string;
        objectTypeImg: string;
        depth: number;
    }


    export interface ObjektAdresseZuord {
        id: string;
        objectID: string;
        addressType?: number;
        addressContact: number;
        adressNumber: number;
        adressID: string;
        contactID?: string;
    }

    export interface ObjektReferenzInfos {
        hatUnterobjekte: number;
        anzDokumente: number;
        anzAufgaben: number;
        anzNotizen: number;
        anzTermine: number;
        anzZeitkontrolle: number;
        anzAuslastungsplanung: number;
        anzEinsatzplanung: number;
        anzWL: number;
    }

    export interface ObjektAdresseDialogInput {
        objektAdresseZuord: ObjektAdresseZuord;
        blDoCheckUnique: boolean;
        blDisableAdrTypeSelect: boolean;
    }

    export interface ObjektRapportDialogInput {
        objectID: string;
        mitarbeiter: string;
        pdfList: DokumentInfo[];
    }

    export interface ObjektRapportPosition {
        id_ObjektRapportPosition: string;
        objectID: string;
        datum: string;
        mitarbeiter: string;
        arbeitsbezeichnung: string;
        aufwandInStunden: number;
        preis: number;
        preisStr: string;
        rabatt?: number | undefined;
        total: number;
        totalStr: string;
    }

    export interface ObjektDialogInput {
        parentObjectID: string;
        objectType?: string;
    }

    export interface ObjektDialogResult {
        objektElement: ObjektElement;
        objektAdresseZuord?: ObjektAdresseZuord;
        swissFields: SwissFieldBase<any>[];
    }

    export interface ObjektAdresse {
        id: string;
        addressType?: number;
        addressTypeDescription?: string;
        adressID: string;
        firstName: string;
        lastName: string;
        fullName: string;
        street1: string;
        zip: string;
        city: string;
        phone01: string;
        contactID?: string;
        attentionOf?: string;
        email?: string;
        mobile?: string;
    }

    export interface ObjektAdresseShort {
        adressID: string;
        firstName: string;
        lastName: string;
        fullName: string;
        street1: string;
        zip: string;
        city: string;
        phone01: string;
        attentionOf?: string;
        email?: string;
        mobile?: string;
    }

    export interface ObjektAktivitaetListElement {
        id: string;
        objectID: string;
        art: number;
        documentName: string;
        description: string;
        datum: Date;
        imageFile: string;
        firstName: string;
        lastName: string;
        ansprechVorname: string;
        ansprechName: string;
        sA_TransDocType?: number;
        lastModified: Date;
    }

    export interface ObjektDatei {
        documentID: string;
        description: string;
        objectID: string;
        fileName: string;
        binary: Blob;
        lastModified: Date;
    }

    export interface ObjektAktivitaetDatei extends ObjektDatei {
    }

    export interface ObjektNotizblattDatei extends ObjektDatei {
    }

    export interface ObjektOfflineStatus {
        offlineID: string;
        objectID: string;
        abzugDatum: Date;
    }

    export interface PencilNotes {
        documentID: string;
        objectID: string;
        doc: jsPDF;
        pdf: any;
        employee: any;
        output: any;
        name: string;
    }

    export interface WebCamImageData {
        imageName: string;
        imageBlob: Blob;
    }

    export interface ObjektType {
        typeNumber: number;
        typeDescription: string;
        treeFields: string;
        treeSort: string;
        imagePath: string;
        sortSwitchValue: number;
    }

    /* Objektsuche nach mehreren Feldern */

    export interface ObjektStatus {
        id: number;
        description: string;
        vinavonTree: boolean;
    }

    export interface ObjektOrt {
        zip: string;
        town: string;
    }

    export interface Projektleiter {
        id: number;
        bezeichnung: string;
    }

    export interface ObjektSucheDaten {
        objektStatus: ObjektStatus[];
        objektOrte: ObjektOrt[];
        projektleiter: Projektleiter[];
    }

    export interface ObjektFilter {
        objektstatus: string;
        projektleiter: string;
        objektorte: string;
        note4: string;
    }

}
